import { gql } from "@apollo/client";

export const GetInterventionNotifications = gql`
  query GetInterventionNotifications {
    interventionNotifications {
      _id
      machineId
      machineName
      createdAt
    }
  }
`;
